import type { ResourceServiceType } from "@core-ui/ContextServices/ResourceService/ResourceService";
import { addToGallery, findNodePos } from "@ext/markdown/elements/gallery/edit/logic/addToGallery";
import saveImageFile from "@ext/markdown/elements/image/edit/logic/saveImageFile";
import type { JSONContent } from "@tiptap/core";
import type { Node } from "prosemirror-model";
import type { EditorView } from "prosemirror-view";

export const saveGalleryImages = async (
	files: File[],
	fileName: string,
	resourceService: ResourceServiceType,
): Promise<JSONContent[]> => {
	const content: JSONContent[] = [];
	for (const file of files.filter((file) => file?.type.startsWith("image"))) {
		content.push({ type: "image", attrs: await saveImageFile(file, fileName, resourceService) });
	}
	return content;
};

const createGallery = async (
	files: File[],
	view: EditorView,
	fileName: string,
	resourceService: ResourceServiceType,
) => {
	const content = await saveGalleryImages(files, fileName, resourceService);
	if (!content.length || view.isDestroyed) return;

	const { schema, tr } = view.state;
	const items = content.map((item) => schema.nodeFromJSON(item));
	view.dispatch(tr.replaceSelectionWith(schema.nodes.gallery.create(null, items)));
};

export const addImagesToGallery = async (
	files: File[],
	view: EditorView,
	target: Node,
	fileName: string,
	resourceService: ResourceServiceType,
) => {
	const content = await saveGalleryImages(files, fileName, resourceService);
	if (!content.length || view.isDestroyed) return;

	const { schema, doc, tr } = view.state;
	const items = content.map((item) => schema.nodeFromJSON(item));
	const targetPos = findNodePos(doc, target);
	if (targetPos !== null) return view.dispatch(addToGallery(tr, targetPos, items));

	view.dispatch(tr.replaceSelectionWith(items.length > 1 ? schema.nodes.gallery.create(null, items) : items[0]));
};

export default createGallery;
